
export default {
  init() {
    /* eslint-disable */
    return import(/* webpackChunkName: "era" */ '../util/era').then(({ default: startEraStory }) => {
      startEraStory();
    });
  },
  finalize() {
    // JavaScript to be fired after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/page-template-page-the-era.js